const map = (key, map) => map[key]
const companyTypeToCommunicationInfoTypeMap = {
    APPLICATION_SERVICE_PROVIDER: null,
    TOUR_OPERATOR: 'AGENCY_DISTRIBUTOR',
    TOUR_AGENCY: 'AGENCY_DISTRIBUTOR',
    WAITING_REGISTRATION: 'AGENCY_DISTRIBUTOR',
    HUB_SUPPLIER: 'SUPPLIER',
    HOTEL_GROUP: null,
    EXTERNAL_SUPPLIER: 'SUPPLIER',
    OWNER: null,
    PARTNER: null,
    TRANSPORT: null,
    GUIDE: null,
    SUPPLEMENTAL: null,
    TOUR_OPERATOR_1LEVEL: 'SYSTEM',
    INTERNAL_SUPPLIER: 'SUPPLIER',
    CORPORATOR: 'CORPORATE_CLIENT',
    GROUP: null,
    EXTRA_SERVICE_SUPPLIER: 'SUPPLIER',
    WAITING_REGISTRATION_SUPPLIER: 'SUPPLIER',
}

export const CompanyTypeToCommunicationInfoType = companyType => map(companyType, companyTypeToCommunicationInfoTypeMap)
